// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__dydEr","title":"FrontImage_title__VbWLg"};